/**
 * Lazy store access without `require()` (unavailable in Vite browser ESM builds).
 * Bound once from redux/index after createStore — breaks Client ↔ redux cycles.
 */
type AppStore = {
    getState: () => AnyObj;
    dispatch: (action: AnyObj) => unknown;
};

let boundStore: AppStore | null = null;

export function bindStore(store: AppStore) {
    boundStore = store;
}

export function getStore(): AppStore {
    if (!boundStore)
        throw new Error('Redux store is not bound yet');
    return boundStore;
}
